// Standalone so it can be imported by both `utils/index.js` and the Toast
// component without creating a utils <-> components import cycle (the barrel
// import in utils/index pulls in Toast, which needs randomId at module eval).
export const randomId = () => (Math.random() + 1).toString(36).substring(7);
